<ng-container *ngFor="let item of data">
  <p-toast></p-toast>
  <div *ngIf="!processLoading" class="request-card">
    <div class="left">
      <div class="top">
        <span class="method">{{ item.method }}</span
        ><span class="url">{{ item.url }}</span>
      </div>
      <span class="date-time"
        ><img src="../../../../assets/icons/clock-icon.svg" class="clock" />{{
          formatDate(item.createdAt)
        }}</span
      >
    </div>
    <div class="middle">
      <div
        [ngClass]="
          item.status === 'Completed'
            ? 'success'
            : item.status === 'Processing'
            ? 'pending'
            : 'failed'
        "
        class="bottom"
      >
        <span
          [ngClass]="
            item.status === 'Failed' || 'Processing'
              ? 'bottom-1-failed'
              : 'bottom-1'
          "
          >{{ item.status }}</span
        ><span *ngIf="item.responseStatus" class="bottom-2">{{
          item.responseStatus
        }}</span>
      </div>
    </div>
    <div class="right">
      <div class="resend-holder">
        <span (click)="resend(item._id)" class="resend"
          >Resend <img src="../../../assets/icons/refresh.svg" alt=""
        /></span>
      </div>
      <div class="resend-holder">
        <span (click)="view(item._id)" class="resend"
          >View <img src="../../../assets/icons/open.svg" alt=""
        /></span>
      </div>
    </div>
  </div>
</ng-container>
<div *ngIf="processLoading">
  <ngx-skeleton-loader></ngx-skeleton-loader>
  <ngx-skeleton-loader></ngx-skeleton-loader>
  <ngx-skeleton-loader></ngx-skeleton-loader>
</div>
<div *ngIf="data.length == 0" class="empty-state">
  <span class="empty-header">No Data Found</span>
  <span class="empty-body">You don't have any requests from your webhooks</span>
</div>
